const severities = ['minor', 'moderate', 'high', 'severe', 'extreme'];

function getIndex(a) {
	let index = a.severity ? severities.indexOf(a.severity.toLocaleLowerCase()) : 0;
	return index === -1 ? 0 : index;
}

//Get alert with highest severity from array of alerts.
function getAlertColor(alerts) {
	if (!alerts) return severities[0];
	//Sometimes there is an object alerts.alerts with the usual array
	if (alerts.alerts) { alerts = alerts.alerts; }

	//Sometimes it comes in a single object
	if (!Array.isArray(alerts)) {
		return severities[getIndex(alerts)];
	}
	//Not an object or now an array
	let topIndex = alerts.reduce((p, a) => Math.max(getIndex(a), p), 0);

	return severities[topIndex];
}
export default getAlertColor;
